import {Box} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';

export const Divider = styled(Box, {
	width: 1,
	backgroundColor: '$neutral92',
	borderRadius: 1,
});
